import React from 'react'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeftOutlined } from '@ant-design/icons'

interface BackButtonProps {
  onClick?: () => void
  to?: string
  text?: string
  style?: React.CSSProperties
  className?: string
  icon?: boolean
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  to,
  text,
  style = { marginBottom: '16px' },
  className,
  icon = false
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (to) {
      navigate(to)
    } else {
      navigate(-1)
    }
  }

  const buttonText = text || t('back', { ns: 'buttons' })

  return (
    <Button 
      onClick={handleClick} 
      style={style}
      className={className}
      icon={icon ? <ArrowLeftOutlined /> : undefined}
    >
      {!icon && '← '}{buttonText}
    </Button>
  )
}

export default BackButton
